<template>
  <div class="global-settings">
    <h1 class="title--1 title--unspaced">
      Très bien.
      <br />Maintenant, dites-nous en plus.
    </h1>

    <div class="global-settings__block">
      <Coworkers />
    </div>
  </div>
</template>

<script>
import { Coworkers } from '../SettingsBlocks';

export default {
  components: {
    Coworkers,
  },
};
</script>
